import React from 'react';
import { RotateLeft } from '@material-ui/icons';
import { Link } from '@material-ui/core';

import { ApolloError, useMutation } from '@apollo/client';
import { Toast } from 'components/Toast';
import { getFriendlyErrorMessage } from 'utils/errorHelper';
import { TRY_TRANSLATING_THE_TITLE_AGAIN } from 'queries/titleContent';
import Swal from 'sweetalert2';
import { StatusType } from '../../enums/status-type.enum';
import useStyles from '../FormContents/components/ActionButtons/styles';

interface ITitleTranslateTryAgainProps {
  title: ITitle;
  refetch: () => void;
}

export const TitleTranslateTryAgain: React.FC<ITitleTranslateTryAgainProps> = ({
  title,
  refetch,
}) => {
  const classes = useStyles();

  const handleOnCompletedMutation = () => {
    Toast('Action executed with success!');
    refetch();
  };

  const handleOnErrorMutation = (error: ApolloError) => {
    Toast(getFriendlyErrorMessage(error), 'error');
  };

  const [translateTitle] = useMutation(TRY_TRANSLATING_THE_TITLE_AGAIN, {
    onCompleted: handleOnCompletedMutation,
    onError: handleOnErrorMutation,
  });

  const confirmAlert = async (subtitle: string) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      html: subtitle,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#78001b',
      reverseButtons: true,
      confirmButtonText: 'Confirm',
      customClass: {
        container: classes.swalDialog,
      },
    });
    return result.value;
  };

  const createTranslation = async () => {
    if (await confirmAlert('Do you want to translate this article again?')) {
      translateTitle({
        variables: {
          id: title.id,
        },
      });
    }
  };

  if (
    title.id &&
    [StatusType.ErrorWhenTranslating, StatusType.Revision].includes(
      title.status,
    )
  ) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <Link
        onClick={() => createTranslation()}
        title="Translate title: try again"
      >
        <RotateLeft
          style={{
            marginRight: '8px',
            marginTop: '3px',
            width: '22px',
          }}
        />
      </Link>
    );
  }

  return <></>;
};
